import {resource} from '@albert-io/json-api-framework/request/builder';
import sessionStore from 'client/Session/SessionStore';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';
import {List} from 'immutable';

export const getStandardSetQuery = (searchString = '') => {
  const baseQuery = resource('standard_sets_v1')
    .mandarkEndpoint(['standard_sets_v1'])
    .withMeta('standard_set_v1');

  if (searchString.length > 0) {
    return baseQuery
      .filter({
        any_of: [
          {
            title: {search_keyword: searchString}
          },
          {
            description: {search_keyword: searchString}
          }
        ]
      })
      .meta({context: {search: {fields: 'title,description', term: searchString}}})
      .sort('-meta.search_relevance');
  }
  return baseQuery;
};

export default getStandardSetQuery;

export const getStandardsQuery = (
  standardSetIds,
  search = '',
  filterPersonalization = false,
  classrooms = List()
) => {
  let pageSize = 'infinite';
  if (search.length || !filterPersonalization || classrooms.isEmpty()) {
    pageSize = 250;
  }
  const standardSetFilterConditions = [];

  if (standardSetIds) {
    standardSetFilterConditions.push({standard_set_v1: {id: standardSetIds}});
  }
  // only filter by classroom subjects on initial perosnalization load
  // see: https://learnerator.slack.com/archives/C05T0FSKYAK/p1709847011065509
  if (filterPersonalization && !classrooms.isEmpty() && !search.length && !standardSetIds.length) {
    const subjectIDs = classrooms.flatMap((classroom) =>
      classroom.getSubjects().map((subject) => subject.getId())
    );
    if (!subjectIDs.isEmpty()) {
      standardSetFilterConditions.push({
        standard_set_v1: {
          subjects_v2: {
            id: subjectIDs.join(',')
          }
        }
      });
    }
  }
  const baseQuery = resource('standards_v1')
    .mandarkEndpoint(['standards_v1'])
    .withMeta('standard_v1')
    .include('standard_set_v1')
    .filter({all_of: standardSetFilterConditions})
    .meta({
      context: {
        question_count: true,
        user: {
          id: sessionStore.getUserId(),
          personalization_settings: true
        }
      }
    })
    .filter({
      'meta.question_count': {
        greater_than: 0
      }
    })
    .filter(
      {
        'meta.included_in_personalization_settings': true
      },
      filterPersonalization
    )
    .pageSize(pageSize)
    .sort('title');

  if (search?.length > 0) {
    return baseQuery
      .filter(
        {
          any_of: [
            {
              title: {search_keyword: search}
            },
            {
              description: {search_keyword: search}
            }
          ]
        },
        !!search.length
      )
      .meta({
        context: {
          search: {
            fields: 'title,description',
            term: search
          }
        }
      })
      .sort('-meta.search_relevance');
  }
  return baseQuery;
};

export const getSearchResults = (standardSetIds, search, filterPersonalization, classrooms) => {
  return getStandardsQuery(
    standardSetIds,
    search,
    filterPersonalization,
    classrooms
  ).getResourcePromise();
};

export const getPersonalizedStandardSetsQuery = () => {
  return resource('standard_sets_v1')
    .mandarkEndpoint(['standard_set_creators_v1'])
    .include('standard_sets_v1')
    .filter({
      users_v2: {id: masqueradeStore.getUserIdByMasqueradeState()}
    });
};

export const getClassroomsWithSubjectsQuery = () => {
  return resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .filter({
      school_v5: masqueradeStore.getSchoolId()
    })
    .filter({
      status: 'active'
    })
    .include('subjects_v2');
};
